import {
  GET_ALL_PROPERTIES_REQUEST,
  GET_ALL_PROPERTIES_REQUEST_CHAT,
  GET_PROPERTY_REQUEST_DETAILS,
} from "./actions";

const initialState = {
  propertyRequestList: {
    docs: [],
    totalDocs: 0,
    limit: 10,
    page: 1,
    totalPages: 0,
    pagingCounter: 0,
    hasPrevPage: false,
    hasNextPage: false,
    prevPage: null,
    nextPage: null,
  },
  propertyRequestData: {},
  messageList: [],
  loading: true,
};

const propertyRequestReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case GET_ALL_PROPERTIES_REQUEST:
      return {
        ...state,
        propertyRequestList: payload,
        loading: false,
      };
    case GET_PROPERTY_REQUEST_DETAILS:
      return {
        ...state,
        propertyRequestData: payload,
        loading: false,
      };
    case GET_ALL_PROPERTIES_REQUEST_CHAT:
      return {
        ...state,
        messageList: payload,
        loading: false,
      };
    default:
      return state;
  }
};
export default propertyRequestReducer;
